import k from '../constants/k'
import player from '../components/player'
import arrow from '../components/arrow'
import useInventory from '../components/inventory'
import { mouse, addHoverEffect } from '../components/mouse'
import { addIngredient } from '../components/ingredient'
import book from '../components/book'

k.loadSprite('forest-background', 'sprites/backgrounds/forest.png')

k.loadSprite('mushrooms', 'sprites/ingredients/mushrooms.png')
k.loadSprite('ghostpipes', 'sprites/ingredients/ghostpipes.png')

export default () => {
  k.add([k.sprite('forest-background'), k.area(), 'background'])
  const { cursor } = mouse()
  const inventory = useInventory(cursor)
  book(cursor)

  const mushrooms = k.add([
    k.sprite('mushrooms'),
    k.area(),
    k.pos(125, 104),
    k.scale(1),
    k.anchor('center')
  ])
  addHoverEffect(mushrooms, cursor)
  mushrooms.onClick(() => addIngredient(inventory, 'mushroom'))

  const ghostpipes = k.add([
    k.sprite('ghostpipes'),
    k.area(),
    k.pos(40, 74),
    k.scale(1),
    k.anchor('center')
  ])
  addHoverEffect(ghostpipes, cursor)
  ghostpipes.onClick(() => addIngredient(inventory, 'ghostpipe'))

  player()

  arrow('left', 'garden', cursor)
  arrow('right', 'lake', cursor)
}
